module.exports = __webpack_public_path__ + "static/recruit-cab0721fd9b520b99cba458318941811.png";